module.exports = __webpack_public_path__ + "static/media/anvil-squad1.b5c67bba.jpg";